import React from 'react'

const ApproachBanner = () => {
    return (
        <section className="main">
            <div className="container">
                <div className="row">
                    <div className="flex flex-row items-center">
                        <div className="w-1/2">
                            <h2>We're conscientious, and we listen...</h2>
                        </div>
                        <div className="w-1/2">
                            <p className="splurge">We don’t have any charts or diagrams that explain how we work. And we don’t have clever names for the stages of our projects.</p>
                            <p className="splurge">But we do have curiosity. And a passion to please. We believe that to truly make a great product you need to talk about it. You need to discuss and debate it. Pull it apart, then put it back together again. And you need to do all of these things together. Conversation, consideration and collaboration. That’s our process.</p>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default ApproachBanner
